import { render, staticRenderFns } from "./CameraSettings.vue?vue&type=template&id=c6ffeed0&scoped=true"
import script from "./CameraSettings.vue?vue&type=script&lang=js"
export * from "./CameraSettings.vue?vue&type=script&lang=js"
import style0 from "./CameraSettings.vue?vue&type=style&index=0&id=c6ffeed0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ffeed0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2718431902/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6ffeed0')) {
      api.createRecord('c6ffeed0', component.options)
    } else {
      api.reload('c6ffeed0', component.options)
    }
    module.hot.accept("./CameraSettings.vue?vue&type=template&id=c6ffeed0&scoped=true", function () {
      api.rerender('c6ffeed0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CameraSettings.vue"
export default component.exports